module.exports = "/_next/static/files/1fef68ffa7c59b841e20cf77cf31653d.jpg";